export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const options = { year: "numeric", month: "long", day: "2-digit" };

  return date.toLocaleDateString("en-US", options);
}
